export default __webpack_public_path__ + "static/media/i100hk.f2f95f4c.webp";